export enum Steps {
  UPLOAD_ADDITIONAL_FILES = "UploadAdditionalFiles",
  ANYTHING_ELSE_TO_SHARE = "AnythingElseToShare",
  UPLOAD_ADDITIONAL_FILES_SUCCESS = "UploadAdditionalFilesSuccess"
}
